import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  logo: {
    width: '350px'
  }
});
const Logo = () => {
  const { logo } = useStyles();
  return <img src="images/login/logo.png" alt="logo" className={logo} />;
};

export default Logo;
